import { useMemo } from 'react';
import { useQueries } from '@tanstack/react-query';
import { fetchExpertReportBlocks } from './api';
import { expertReportKeys } from './hooks';
import type { ExpertReportBlockTreeNode } from './types';

/** Соответствие reportId → дерево блоков экспертного заключения */
export type ExpertReportBlocksTreeMap = Map<number, ExpertReportBlockTreeNode[]>;

/**
 * Загружает деревья блоков для указанных экспертных заключений и возвращает
 * `reportId → дерево блоков` (без потери вложенности) — используется для построения вложенных
 * групп колонок блоков в таблице диалогов и для перечисления листовых блоков (видимость,
 * параметры запроса).
 */
export const useExpertReportsBlocksTree = (reportIds: number[]): ExpertReportBlocksTreeMap => {
  const queries = useQueries({
    queries: reportIds.map((id) => ({
      queryKey: expertReportKeys.blocks(id),
      queryFn: () => fetchExpertReportBlocks(id),
      staleTime: 60_000,
    })),
  });

  return useMemo(() => {
    const map: ExpertReportBlocksTreeMap = new Map();
    queries.forEach((q, index) => {
      map.set(reportIds[index], q.data?.blocks ?? []);
    });
    return map;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queries.map((q) => q.dataUpdatedAt).join('|'), reportIds.join(',')]);
};
